import { A } from '@adornis/base/env-info.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Names } from '@ils/static/names.js';

@Entity()
export class ExamSlotRating extends AdornisEntity {
  static override _class = Names.ExamSlotRating._class;

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(type => String)
  instructionId!: string;

  /**
   * 0, 1 or 2: no, maybe, yes
   */
  @Field(type => Float)
  score!: number;

  @Field(type => String)
  notes?: string;
}
